import {useParams} from 'react-router-dom'
import {useEffect, useState} from "react";
import {Spinner} from "../components";
import {parcelDetails} from "../services/service";

const Logs = () => {
    const {id} = useParams()

    const [data, setData] = useState(false)


    const getData = async () => {


        const formData = new FormData();
        formData.append("tracking_code", id);

        const response = await parcelDetails(formData)
        if (response && response.data.code==1) {

            setData(response.data)
        }
    }



    useEffect(() => {
        getData()
    },[])


    let content

    if (data) {

        content =
            data.logs.map((log, index) => (
                <>
                    <div className='column is-12 has-text-centered has-text-weight-bold'>
                        {index + 1}
                    </div>


                    <div key={index} className='column is-6 lightborder  has-text-centered'>
                        تاریخ :
                        {'  '}
                        {log.date}
                    </div>


                    <div key={index} className='column is-6 lightborder  has-text-centered'>
                        ساعت :
                        {'  '}
                        {log.clock}
                    </div>

                    <div key={index} className='column is-6 lightborder  has-text-centered'>
                        مرکز :
                        {'  '}
                        {log.location}
                    </div>

                    <div key={index} className='column is-6 lightborder  has-text-centered'>
                        رویداد :
                        {'  '}
                        {log.description}
                    </div>
                </>


            ))


    } else {
        content =

            <div className='is-flex is-justify-content-center'>
                <Spinner/>
            </div>

    }


    return (
        <>
            <div className='columns p-5 is-mobile  is-multiline yekan '>

                {
                    content
                }
            </div>


        </>
    )
}
export default Logs;